export default {
  state() {
    return {};
  },
};
